export class Helper {
    static getObjectFromAnArrayByObjectId(arr: any, id: string) {
        for (let obj of arr) {
            if (obj.id == id) {
                return obj;
            }
        }
    }
}